module.exports = __webpack_public_path__ + "img/pay-icon-2.0c7d9334.png";